var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioEquilizer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 329,
    viewBox: "0 0 27 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: "rotate(180deg)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9628_28365",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 329
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 329,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9628_28365)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -2,
    width: 27,
    height: 330,
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -1,
    width: 27,
    height: 0,
    fill: "url(#paint0_linear_9628_28365)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9628_28365",
    x1: 13.5,
    y1: -1,
    x2: 13.5,
    y2: 329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#009B54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#FAE62B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583333,
    stopColor: "#E82D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E61385"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioEquilizer);
export default __webpack_public_path__ + "static/media/audio_equilizer.85733547d023bbe6503fd9bf46edd2b3.svg";
export { ForwardRef as ReactComponent };